import Resource from '@/api/resources/Resource'

class ComplementaryCodificationServices extends Resource {
    async getCodifications(labId, caseId, complementaryId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/complementaries/${complementaryId}/codifications`)
        return response.data
    }
    async createBatchCodifications(labId, caseId, complementaryId, codificationRequests) {
        const response = await this.axios.post(`/laboratories/${labId}/cases/${caseId}/complementaries/${complementaryId}/codifications/createBatch`, codificationRequests)
        return response.data
    }
    async deleteBatchCodifications(labId, caseId, complementaryId, codificationIds) {
        const params = {
            entityIdentifiers: codificationIds.map(codification => codification.id)
        }
        const response = await this.axios.delete(`/laboratories/${labId}/cases/${caseId}/complementaries/${complementaryId}/codifications/deleteBatch`, { data: params })
        return response.data
    }
    async updateBatchCodifications(labId, caseId, complementaryId, updateRequests) {
        const response = await this.axios.put(`/laboratories/${labId}/cases/${caseId}/complementaries/${complementaryId}/codifications/updateBatch`, updateRequests)
        return response.data
    }
}

export default new ComplementaryCodificationServices()
